import NudosSearchBar from './NudosSearchBar';

export default NudosSearchBar;
